import { Injectable } from '@angular/core';
import { DIMBO_CONSTANT } from '../utils/constant';

@Injectable({
    providedIn: 'root'
})
// Simple cache wrapper: session/local storage plus in‑memory store for sensitive keys.
export class CacheService {
    private inMemoryStore: Record<string, any> = {};
    constructor() { }

    // Keys holding personal / JWT payload data
    private readonly sensitiveKeys = new Set<string>([
        DIMBO_CONSTANT.CACHE_BRANDCARE_TITLE,
        DIMBO_CONSTANT.CACHE_JWT_TOKEN,
        DIMBO_CONSTANT.CACHE_JWT_TOKEN_RESPONSE,
        DIMBO_CONSTANT.CACHE_JWT_ISS,
        DIMBO_CONSTANT.CACHE_JWT_LANGUAGE,
        DIMBO_CONSTANT.CACHE_JWT_LANGUAGE_RAW,
        DIMBO_CONSTANT.CACHE_JWT_LOCALE,
        DIMBO_CONSTANT.CACHE_JWT_USER_ID,
        DIMBO_CONSTANT.CACHE_JWT_RRDI,
        DIMBO_CONSTANT.CACHE_JWT_MODEL,
        DIMBO_CONSTANT.CACHE_JWT_VIN_BRAND,
        DIMBO_CONSTANT.CACHE_JWT_VIN_RRDI,
        DIMBO_CONSTANT.CACHE_JWT_ENGINE_TYPE,
        DIMBO_CONSTANT.CACHE_JWT_VEHICLE_TYPE,
        DIMBO_CONSTANT.CACHE_JWT_WARRANTY_START_DATE,
        DIMBO_CONSTANT.CACHE_JWT_CONTRIBUTION_FLAG,
        DIMBO_CONSTANT.CACHE_JWT_VIN,
        DIMBO_CONSTANT.CACHE_JWT_MILEAGE,
        DIMBO_CONSTANT.CACHE_JWT_RECEPTION_RRDI,
        DIMBO_CONSTANT.CACHE_JWT_FIRST_REGISTRATION_DATE,
        DIMBO_CONSTANT.CACHE_JWT_EMAIL,
        DIMBO_CONSTANT.CACHE_JWT_WORK_LINES,
        DIMBO_CONSTANT.CACHE_JWT_FOLDER_PNR_ID,
        DIMBO_CONSTANT.CACHE_JWT_FOLDER_DMS_ID
    ]);

    // Method to set a item to cache (session storage)
    public setItem(key: string, item: any): void {
        if (this.sensitiveKeys.has(key)) {
            this.inMemoryStore[key] = item;
            return;
        }
        if (typeof item != "string") {
            item = JSON.stringify(item);
        } else {
            item = JSON.stringify(new String(item));
        }
        sessionStorage.setItem(key, item);
    }

    // Method to get a item from cache (session storage)
    public getItem(key: string): any {
        if (this.sensitiveKeys.has(key)) {
            return this.inMemoryStore[key];
        }
        let item = sessionStorage.getItem(key);
        if (item && item != 'undefined') {
            return JSON.parse(item);
        } else {
            return undefined;
        }
    }

    // Method to remove a item from cache (session storage)
    public removeItem(key: string) {
        sessionStorage.removeItem(key);
        return 1;
    }

    // Method to clear the cache (session + local storage)
    public clear() {
        //   sessionStorage.clear();
        this.clearDmbrSessionData();
        //   localStorage.clear();
        this.inMemoryStore = {};
        return 1;
    }

    // Method to set a item to cache (local storage)
    public setItemLocalStorage(key: string, item: any) {
        if (typeof item != "string") {
            item = JSON.stringify(item);
        } else {
            item = JSON.stringify(new String(item));
        }
        localStorage.setItem(key, item);
    }

    // Method to get a item from cache (local storage)
    public getLocalStorageItem(key: string) {
        var item = localStorage.getItem(key);
        if (item && item != 'undefined') {
            return JSON.parse(item);
        } else {
            return undefined;
        }
    }

    // Method to remove a item from cache (local storage)
    public removeItemLocalStorage(key: string) {
        localStorage.removeItem(key);
        return 1;
    }

    public clearDmbrSessionData() {
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN_RESPONSE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_ISS);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE_RAW);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_LOCALE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_USER_ID);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_RRDI);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_MODEL);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_VIN_BRAND);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_VIN_RRDI);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_ENGINE_TYPE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_VEHICLE_TYPE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_WARRANTY_START_DATE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_CONTRIBUTION_FLAG);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_RECEPTION_RRDI);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_FIRST_REGISTRATION_DATE);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_EMAIL);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_WORK_LINES);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_FOLDER_PNR_ID);
        this.removeItem(DIMBO_CONSTANT.CACHE_JWT_FOLDER_DMS_ID);
        this.removeItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER);
        this.removeItem(DIMBO_CONSTANT.CACHE_FORM_DATA);
        this.removeItem(DIMBO_CONSTANT.CACHE_INITIAL_MILEAGE_PROMPT);
        this.removeItem(DIMBO_CONSTANT.CACHE_BRANDCARE_TITLE);
        this.inMemoryStore = {};
    }

}
